import React from 'react';
import browser from 'bowser';
import classnames from 'classnames';

import Row from '../../components/row';
import Title from '../../components/title';
import Capullo2011 from './capullo-2011.png';
import Capullo2012 from './capullo-2012.png';
import Capullo2013 from './capullo-2013.png';
import Capullo2014 from './capullo-2014.png';
import Capullo2015 from './capullo-2015.png';
import Capullo2016 from './capullo-2016.png';

const TripAdvisor = () => {
  const mobile = browser.mobile;
  return (
    <Row>
      <Title title="Nuestros Certificados" />
      <div className="row mt30">
        <div className="col-sm-4 text-center">
          <Item url={Capullo2016} />
        </div>
        <div className="col-sm-4 text-center">
          <Item url={Capullo2015} />
        </div>
        <div className="col-sm-4 text-center">
          <Item url={Capullo2014} />
        </div>
      </div>
      <div className={classnames('row', {mt30: !mobile})}>
        <div className="col-sm-4 text-center">
          <Item url={Capullo2013} />
        </div>
        <div className="col-sm-4 text-center">
          <Item url={Capullo2012} />
        </div>
        <div className="col-sm-4 text-center">
          <Item url={Capullo2011} />
        </div>
      </div>
      <div className="clearfix"></div>
    </Row>
  );
};

export const Item = ({url}) => {
  const capulloRef = 'https://www.tripadvisor.com/Hotel_Review-g298066-d1489266-Reviews-El_Capullo-Colonia_del_Sacramento_Colonia_Department.html';
  const style = { maxHeight: '200px', maxWidth: '200px', border: 'solid white 20px'};

  return (
    <div>
      <a target="_blank" rel="noopener" href={capulloRef}>
        <img style={style} src={url} alt="TripAdvisor" />
      </a>
    </div>
  );
};

export default TripAdvisor;



// WEBPACK FOOTER //
// ./src/home/trip-advisor/index.js